import { useQuery } from "@tanstack/react-query";
import { getEmployee } from "../employees";

export const employeeKeys = {
  all: ["employee"] as const,
  byId: (id: number) => ["employee", id] as const,
};

export function useEmployee(id?: number) {
  return useQuery({
    queryKey: employeeKeys.byId(Number(id)),
    queryFn: () => getEmployee(Number(id)),
    enabled: typeof id === "number" && Number.isFinite(id) && id > 0,
  });
}
